import { utcToZonedTime } from "date-fns-tz";
import { ClassScheduleItem } from "./useTodaysClasses";
import { MemberProfileFragment } from "../../../components/controllers/MemberProfileSelect/MemberProfileSelect-generated.hooks";

export const DashboardCheckinSource = "Core - dashboard";

export type AttendeeStatus =
  | "checkedin"
  | "reserved"
  | "no show"
  | "waitlisted"
  | "late cancel"
  | "cancelled";

export type StaffRole = "member" | "coach" | "assistant coach" | "admin";

export type SelectedMember = MemberProfileFragment & {
  role?: StaffRole;
  subscriptionUuid?: string;
  status?: AttendeeStatus;
  registrationUuid?: string;
  checkinUuid?: string;
  primaryImage?: string;
  membershipRole?: string;
};

export const mapAttendeeToSelectedMember = (attendee) => {
  if (!attendee) return;
  return {
    userUuid: attendee.userUuid,
    firstName: attendee.customerName.split(" ")[0],
    lastName: attendee.customerName.split(" ")[1] || "",
    clientUserUuid: attendee.userUuid,
    status: attendee.status as AttendeeStatus,
    registrationUuid: attendee.uuid,
    checkinUuid: attendee.checkinUuid,
    role: (attendee.membershipRole as StaffRole) || "member",
    isStaff:
      attendee.membershipRole === "coach" ||
      attendee.membershipRole === "admin",
    primaryImage: attendee?.primaryImage || "",
    membershipRole: attendee?.membershipRole,
  };
};

export const getDefaultSelectedClass = (
  todaysClasses: ClassScheduleItem[],
  clientTimezone: string,
): string => {
  if (!todaysClasses || todaysClasses.length === 0) {
    return "";
  }

  const nowInClientTz = utcToZonedTime(new Date(), clientTimezone);

  const currentClass = todaysClasses.find((cls) => {
    return cls.startTime <= nowInClientTz && cls.endTime >= nowInClientTz;
  });

  if (!currentClass) {
    return todaysClasses[0]?.id || "";
  }

  return currentClass.id;
};
